/* main.js */

var app = {};

var ActualPathName = window.location.href;


jQuery(function() {
    jQuery(".pc_nav>li").hover(function() {
        jQuery(this).addClass('active');
        var sub = jQuery(this).find('.pc_nav_sub');
        if (sub.length > 0) {
            sub.slideDown(200);
        }
    }, function() {
        jQuery(this).removeClass('active');
        var sub = jQuery(this).find('.pc_nav_sub');
        if (sub.length > 0) {
            sub.hide();
        }
    });
});

/* LAZY LOADING */

  (function(q,m){"function"===typeof define&&define.amd?define(m):"object"===typeof exports?module.exports=m():q.Blazy=m()})(this,function(){function q(b){var c=b._util;c.elements=E(b.options);c.count=c.elements.length;c.destroyed&&(c.destroyed=!1,b.options.container&&l(b.options.container,function(a){n(a,"scroll",c.validateT)}),n(window,"resize",c.saveViewportOffsetT),n(window,"resize",c.validateT),n(window,"scroll",c.validateT));m(b)}function m(b){for(var c=b._util,a=0;a<c.count;a++){var d=c.elements[a],e;a:{var g=d;e=b.options;var p=g.getBoundingClientRect();if(e.container&&y&&(g=g.closest(e.containerClass))){g=g.getBoundingClientRect();e=r(g,f)?r(p,{top:g.top-e.offset,right:g.right+e.offset,bottom:g.bottom+e.offset,left:g.left-e.offset}):!1;break a}e=r(p,f)}if(e||t(d,b.options.successClass))b.load(d),c.elements.splice(a,1),c.count--,a--}0===c.count&&b.destroy()}function r(b,c){return b.right>=c.left&&b.bottom>=c.top&&b.left<=c.right&&b.top<=c.bottom}function z(b,c,a){if(!t(b,a.successClass)&&(c||a.loadInvisible||0<b.offsetWidth&&0<b.offsetHeight))if(c=b.getAttribute(u)||b.getAttribute(a.src)){c=c.split(a.separator);var d=c[A&&1<c.length?1:0],e=b.getAttribute(a.srcset),g="img"===b.nodeName.toLowerCase(),p=(c=b.parentNode)&&"picture"===c.nodeName.toLowerCase();if(g||void 0===b.src){var h=new Image,w=function(){a.error&&a.error(b,"invalid");v(b,a.errorClass);k(h,"error",w);k(h,"load",f)},f=function(){g?p||B(b,d,e):b.style.backgroundImage='url("'+d+'")';x(b,a);k(h,"load",f);k(h,"error",w)};p&&(h=b,l(c.getElementsByTagName("source"),function(b){var c=a.srcset,e=b.getAttribute(c);e&&(b.setAttribute("srcset",e),b.removeAttribute(c))}));n(h,"error",w);n(h,"load",f);B(h,d,e)}else b.src=d,x(b,a)}else"video"===b.nodeName.toLowerCase()?(l(b.getElementsByTagName("source"),function(b){var c=a.src,e=b.getAttribute(c);e&&(b.setAttribute("src",e),b.removeAttribute(c))}),b.load(),x(b,a)):(a.error&&a.error(b,"missing"),v(b,a.errorClass))}function x(b,c){v(b,c.successClass);c.success&&c.success(b);b.removeAttribute(c.src);b.removeAttribute(c.srcset);l(c.breakpoints,function(a){b.removeAttribute(a.src)})}function B(b,c,a){a&&b.setAttribute("srcset",a);b.src=c}function t(b,c){return-1!==(" "+b.className+" ").indexOf(" "+c+" ")}function v(b,c){t(b,c)||(b.className+=" "+c)}function E(b){var c=[];b=b.root.querySelectorAll(b.selector);for(var a=b.length;a--;c.unshift(b[a]));return c}function C(b){f.bottom=(window.innerHeight||document.documentElement.clientHeight)+b;f.right=(window.innerWidth||document.documentElement.clientWidth)+b}function n(b,c,a){b.attachEvent?b.attachEvent&&b.attachEvent("on"+c,a):b.addEventListener(c,a,{capture:!1,passive:!0})}function k(b,c,a){b.detachEvent?b.detachEvent&&b.detachEvent("on"+c,a):b.removeEventListener(c,a,{capture:!1,passive:!0})}function l(b,c){if(b&&c)for(var a=b.length,d=0;d<a&&!1!==c(b[d],d);d++);}function D(b,c,a){var d=0;return function(){var e=+new Date;e-d<c||(d=e,b.apply(a,arguments))}}var u,f,A,y;return function(b){if(!document.querySelectorAll){var c=document.createStyleSheet();document.querySelectorAll=function(a,b,d,h,f){f=document.all;b=[];a=a.replace(/\[for\b/gi,"[htmlFor").split(",");for(d=a.length;d--;){c.addRule(a[d],"k:v");for(h=f.length;h--;)f[h].currentStyle.k&&b.push(f[h]);c.removeRule(0)}return b}}var a=this,d=a._util={};d.elements=[];d.destroyed=!0;a.options=b||{};a.options.error=a.options.error||!1;a.options.offset=a.options.offset||100;a.options.root=a.options.root||document;a.options.success=a.options.success||!1;a.options.selector=a.options.selector||".b-lazy";a.options.separator=a.options.separator||"|";a.options.containerClass=a.options.container;a.options.container=a.options.containerClass?document.querySelectorAll(a.options.containerClass):!1;a.options.errorClass=a.options.errorClass||"b-error";a.options.breakpoints=a.options.breakpoints||!1;a.options.loadInvisible=a.options.loadInvisible||!1;a.options.successClass=a.options.successClass||"b-loaded";a.options.validateDelay=a.options.validateDelay||25;a.options.saveViewportOffsetDelay=a.options.saveViewportOffsetDelay||50;a.options.srcset=a.options.srcset||"data-srcset";a.options.src=u=a.options.src||"data-src";y=Element.prototype.closest;A=1<window.devicePixelRatio;f={};f.top=0-a.options.offset;f.left=0-a.options.offset;a.revalidate=function(){q(a)};a.load=function(a,b){var c=this.options;void 0===a.length?z(a,b,c):l(a,function(a){z(a,b,c)})};a.destroy=function(){var a=this._util;this.options.container&&l(this.options.container,function(b){k(b,"scroll",a.validateT)});k(window,"scroll",a.validateT);k(window,"resize",a.validateT);k(window,"resize",a.saveViewportOffsetT);a.count=0;a.elements.length=0;a.destroyed=!0};d.validateT=D(function(){m(a)},a.options.validateDelay,a);d.saveViewportOffsetT=D(function(){C(a.options.offset)},a.options.saveViewportOffsetDelay,a);C(a.options.offset);l(a.options.breakpoints,function(a){if(a.width>=window.screen.width)return u=a.src,!1});setTimeout(function(){q(a)})}});

/* plugins.min.js */
!function(i) {
    "function" == typeof define && define.amd ? define(["jquery"], i) : i("object" == typeof exports ? require("jquery") : jQuery)
}(function(i) {
    function e(i) {
        return r.raw ? i : encodeURIComponent(i)
    }
    ;function t(i) {
        return r.raw ? i : decodeURIComponent(i)
    }
    ;function o(i) {
        return e(r.json ? JSON.stringify(i) : String(i))
    }
    ;function s(i) {
        0 === i.indexOf('"') && (i = i.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
        try {
            return i = decodeURIComponent(i.replace(l, " ")),
            r.json ? JSON.parse(i) : i
        } catch (e) {}
    }
    ;function n(e, t) {
        var o = r.raw ? e : s(e);
        return i.isFunction(t) ? t(o) : o
    }
    ;var l = /\+/g
      , r = i.cookie = function(s, l, d) {
        if (void 0 !== l && !i.isFunction(l)) {
            if (d = i.extend({}, r.defaults, d),
            "number" == typeof d.expires) {
                var a = d.expires
                  , c = d.expires = new Date;
                c.setTime(+c + 864e5 * a)
            }
            return document.cookie = [e(s), "=", o(l), d.expires ? "; expires=" + d.expires.toUTCString() : "", d.path ? "; path=" + d.path : "", d.domain ? "; domain=" + d.domain : "", d.secure ? "; secure" : ""].join("")
        }
        for (var p = s ? void 0 : {}, u = document.cookie ? document.cookie.split("; ") : [], h = 0, f = u.length; f > h; h++) {
            var v = u[h].split("=")
              , k = t(v.shift())
              , y = v.join("=");
            if (s && s === k) {
                p = n(y, l);
                break
            }
            s || void 0 === (y = n(y)) || (p[k] = y)
        }
        return p
    }
    ;
    r.defaults = {},
    i.removeCookie = function(e, t) {
        return void 0 === i.cookie(e) ? !1 : (i.cookie(e, "", i.extend({}, t, {
            expires: -1
        })),
        !i.cookie(e));
    }
    ;
}),
function(i, e) {
    var t = function(i, e, t) {
        var o;
        return function() {
            function s() {
                t || i.apply(n, l),
                o = null
            }
            var n = this
              , l = arguments;
            o ? clearTimeout(o) : t && i.apply(n, l),
            o = setTimeout(s, e || 150)
        }
    };
    jQuery.fn[e] = function(i) {
        return i ? this.bind("resize", t(i)) : this.trigger(e)
    }
    ;
}(jQuery, "smartresize"),
function(i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function(i) {
    "use strict";
    var e = window.Slick || {};
    e = function() {
        function e(e, o) {
            var s, n, l, r = this;
            if (r.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(e),
                appendDots: i(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(i, e) {
                    return '<button type="button" data-role="none">' + (e + 1) + "</button>"
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rtl: !1,
                slide: "",
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                variableWidth: !1,
                vertical: !1,
                waitForAnimate: !0
            },
            r.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1
            },
            i.extend(r, r.initials),
            r.activeBreakpoint = null,
            r.animType = null,
            r.animProp = null,
            r.breakpoints = [],
            r.breakpointSettings = [],
            r.cssTransitions = !1,
            r.hidden = "hidden",
            r.paused = !1,
            r.positionProp = null,
            r.respondTo = null,
            r.shouldClick = !0,
            r.$slider = i(e),
            r.$slidesCache = null,
            r.transformType = null,
            r.transitionType = null,
            r.visibilityChange = "visibilitychange",
            r.windowWidth = 0,
            r.windowTimer = null,
            s = i(e).data("slick") || {},
            r.options = i.extend({}, r.defaults, s, o),
            r.currentSlide = r.options.initialSlide,
            r.originalSettings = r.options,
            n = r.options.responsive || null,
            n && n.length > -1) {
                r.respondTo = r.options.respondTo || "window";
                for (l in n)
                    n.hasOwnProperty(l) && (r.breakpoints.push(n[l].breakpoint),
                    r.breakpointSettings[n[l].breakpoint] = n[l].settings);
                r.breakpoints.sort(function(i, e) {
                    return r.options.mobileFirst === !0 ? i - e : e - i
                })
            }
            "undefined" != typeof document.mozHidden ? (r.hidden = "mozHidden",
            r.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (r.hidden = "msHidden",
            r.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (r.hidden = "webkitHidden",
            r.visibilityChange = "webkitvisibilitychange"),
            r.autoPlay = i.proxy(r.autoPlay, r),
            r.autoPlayClear = i.proxy(r.autoPlayClear, r),
            r.changeSlide = i.proxy(r.changeSlide, r),
            r.clickHandler = i.proxy(r.clickHandler, r),
            r.selectHandler = i.proxy(r.selectHandler, r),
            r.setPosition = i.proxy(r.setPosition, r),
            r.swipeHandler = i.proxy(r.swipeHandler, r),
            r.dragHandler = i.proxy(r.dragHandler, r),
            r.keyHandler = i.proxy(r.keyHandler, r),
            r.autoPlayIterator = i.proxy(r.autoPlayIterator, r),
            r.instanceUid = t++,
            r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            r.init(),
            r.checkResponsive(!0)
        }
        var t = 0;
        return e;
    }(),
    e.prototype.addSlide = e.prototype.slickAdd = function(e, t, o) {
        var s = this;
        if ("boolean" == typeof t)
            o = t,
            t = null;
        else if (0 > t || t >= s.slideCount)
            return !1;
        s.unload(),
        "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : o === !0 ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack),
        s.$slides = s.$slideTrack.children(this.options.slide),
        s.$slideTrack.children(this.options.slide).detach(),
        s.$slideTrack.append(s.$slides),
        s.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e)
        }),
        s.$slidesCache = s.$slides,
        s.reinit();
    }
    ,
    e.prototype.animateHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({
                height: e
            }, i.options.speed);
        }
    }
    ,
    e.prototype.animateSlide = function(e, t) {
        var o = {}
          , s = this;
        s.animateHeight(),
        s.options.rtl === !0 && s.options.vertical === !1 && (e = -e),
        s.transformsEnabled === !1 ? s.options.vertical === !1 ? s.$slideTrack.animate({
            left: e
        }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
            top: e
        }, s.options.speed, s.options.easing, t) : s.cssTransitions === !1 ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft),
        i({
            animStart: s.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function(i) {
                i = Math.ceil(i),
                s.options.vertical === !1 ? (o[s.animType] = "translate(" + i + "px, 0px)",
                s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)",
                s.$slideTrack.css(o));
            },
            complete: function() {
                t && t.call()
            }
        })) : (s.applyTransition(),
        e = Math.ceil(e),
        s.options.vertical === !1 ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)",
        s.$slideTrack.css(o),
        t && setTimeout(function() {
            s.disableTransition(),
            t.call()
        }, s.options.speed));
    }
    ,
    e.prototype.asNavFor = function(e) {
        var t = this
          , o = null !== t.options.asNavFor ? i(t.options.asNavFor).slick("getSlick") : null;
        null !== o && o.slideHandler(e, !0);
    }
    ,
    e.prototype.applyTransition = function(i) {
        var e = this
          , t = {};
        e.options.fade === !1 ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
        e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }
    ,
    e.prototype.autoPlay = function() {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer),
        i.slideCount > i.options.slidesToShow && i.paused !== !0 && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
    }
    ,
    e.prototype.autoPlayClear = function() {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer);
    }
    ,
    e.prototype.autoPlayIterator = function() {
        var i = this;
        i.options.infinite === !1 ? 1 === i.direction ? (i.currentSlide + 1 === i.slideCount - 1 && (i.direction = 0),
        i.slideHandler(i.currentSlide + i.options.slidesToScroll)) : (i.currentSlide - 1 === 0 && (i.direction = 1),
        i.slideHandler(i.currentSlide - i.options.slidesToScroll)) : i.slideHandler(i.currentSlide + i.options.slidesToScroll);
    }
    ,
    e.prototype.buildArrows = function() {
        var e = this;
        e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow = i(e.options.prevArrow),
        e.$nextArrow = i(e.options.nextArrow),
        e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.appendTo(e.options.appendArrows),
        e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
        e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled"));
    }
    ,
    e.prototype.buildDots = function() {
        var e, t, o = this;
        if (o.options.dots === !0 && o.slideCount > o.options.slidesToShow) {
            for (t = '<ul class="' + o.options.dotsClass + '">',
            e = 0; e <= o.getDotCount(); e += 1)
                t += "<li>" + o.options.customPaging.call(this, o, e) + "</li>";
            t += "</ul>",
            o.$dots = i(t).appendTo(o.options.appendDots),
            o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
        }
    }
    ,
    e.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.$slides.each(function(e, t) {
            i(t).attr("data-slick-index", e)
        }),
        e.$slidesCache = e.$slides,
        e.$slider.addClass("slick-slider"),
        e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(),
        e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
        e.$slideTrack.css("opacity", 0),
        (e.options.centerMode === !0 || e.options.swipeToSlide === !0) && (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.options.accessibility === !0 && e.$list.prop("tabIndex", 0),
        e.setSlideClasses("number" == typeof this.currentSlide ? this.currentSlide : 0),
        e.options.draggable === !0 && e.$list.addClass("draggable");
    }
    ,
    e.prototype.checkResponsive = function(e) {
        var t, o, s, n = this, l = n.$slider.width(), r = window.innerWidth || i(window).width();
        if ("window" === n.respondTo ? s = r : "slider" === n.respondTo ? s = l : "min" === n.respondTo && (s = Math.min(r, l)),
        n.originalSettings.responsive && n.originalSettings.responsive.length > -1 && null !== n.originalSettings.responsive) {
            o = null;
            for (t in n.breakpoints)
                n.breakpoints.hasOwnProperty(t) && (n.originalSettings.mobileFirst === !1 ? s < n.breakpoints[t] && (o = n.breakpoints[t]) : s > n.breakpoints[t] && (o = n.breakpoints[t]));
            null !== o ? null !== n.activeBreakpoint ? o !== n.activeBreakpoint && (n.activeBreakpoint = o,
            "unslick" === n.breakpointSettings[o] ? n.unslick() : (n.options = i.extend({}, n.originalSettings, n.breakpointSettings[o]),
            e === !0 && (n.currentSlide = n.options.initialSlide),
            n.refresh())) : (n.activeBreakpoint = o,
            "unslick" === n.breakpointSettings[o] ? n.unslick() : (n.options = i.extend({}, n.originalSettings, n.breakpointSettings[o]),
            e === !0 && (n.currentSlide = n.options.initialSlide),
            n.refresh())) : null !== n.activeBreakpoint && (n.activeBreakpoint = null,
            n.options = n.originalSettings,
            e === !0 && (n.currentSlide = n.options.initialSlide),
            n.refresh())
        }
    }
    ,
    e.prototype.changeSlide = function(e, t) {
        var o, s, n, l = this, r = i(e.target);
        switch (r.is("a") && e.preventDefault(),
        n = l.slideCount % l.options.slidesToScroll !== 0,
        o = n ? 0 : (l.slideCount - l.currentSlide) % l.options.slidesToScroll,
        e.data.message) {
        case "previous":
            s = 0 === o ? l.options.slidesToScroll : l.options.slidesToShow - o,
            l.slideCount > l.options.slidesToShow && l.slideHandler(l.currentSlide - s, !1, t);
            break;
        case "next":
            s = 0 === o ? l.options.slidesToScroll : o,
            l.slideCount > l.options.slidesToShow && l.slideHandler(l.currentSlide + s, !1, t);
            break;
        case "index":
            var d = 0 === e.data.index ? 0 : e.data.index || i(e.target).parent().index() * l.options.slidesToScroll;
            l.slideHandler(l.checkNavigable(d), !1, t);
            break;
        default:
            return
        }
    }
    ,
    e.prototype.checkNavigable = function(i) {
        var e, t, o = this;
        if (e = o.getNavigableIndexes(),
        t = 0,
        i > e[e.length - 1])
            i = e[e.length - 1];
        else {
            for (var s in e) {
                if (i < e[s]) {
                    i = t;
                    break;
                }
                ;t = e[s];
            }
        }
        return i;
    }
    ,
    e.prototype.clickHandler = function(i) {
        var e = this;
        e.shouldClick === !1 && (i.stopImmediatePropagation(),
        i.stopPropagation(),
        i.preventDefault());
    }
    ,
    e.prototype.destroy = function() {
        var e = this;
        e.autoPlayClear(),
        e.touchObject = {},
        i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && "object" != typeof e.options.prevArrow && e.$prevArrow.remove(),
        e.$nextArrow && "object" != typeof e.options.nextArrow && e.$nextArrow.remove(),
        e.$slides.removeClass("slick-slide slick-active slick-center slick-visible").attr("aria-hidden", "true").removeAttr("data-slick-index").css({
            position: "",
            left: "",
            top: "",
            zIndex: "",
            opacity: "",
            width: ""
        }),
        e.$slider.removeClass("slick-slider"),
        e.$slider.removeClass("slick-initialized"),
        e.$list.off(".slick"),
        i(window).off(".slick-" + e.instanceUid),
        i(document).off(".slick-" + e.instanceUid),
        e.$slider.html(e.$slides);
    }
    ,
    e.prototype.disableTransition = function(i) {
        var e = this
          , t = {};
        t[e.transitionType] = "",
        e.options.fade === !1 ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }
    ,
    e.prototype.fadeSlide = function(i, e) {
        var t = this;
        t.cssTransitions === !1 ? (t.$slides.eq(i).css({
            zIndex: 1e3
        }),
        t.$slides.eq(i).animate({
            opacity: 1
        }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i),
        t.$slides.eq(i).css({
            opacity: 1,
            zIndex: 1e3
        }),
        e && setTimeout(function() {
            t.disableTransition(i),
            e.call()
        }, t.options.speed))
    }
    ,
    e.prototype.filterSlides = e.prototype.slickFilter = function(i) {
        var e = this;
        null !== i && (e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
        e.reinit())
    }
    ,
    e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
        var i = this;
        return i.currentSlide
    }
    ,
    e.prototype.getDotCount = function() {
        var i = this
          , e = 0
          , t = 0
          , o = 0;
        if (i.options.infinite === !0)
            o = Math.ceil(i.slideCount / i.options.slidesToScroll);
        else if (i.options.centerMode === !0)
            o = i.slideCount;
        else
            for (; e < i.slideCount; )
                ++o,
                e = t + i.options.slidesToShow,
                t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        return o - 1;
    }
    ,
    e.prototype.getLeft = function(i) {
        var e, t, o, s = this, n = 0;
        return s.slideOffset = 0,
        t = s.$slides.first().outerHeight(),
        s.options.infinite === !0 ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1,
        n = t * s.options.slidesToShow * -1),
        s.slideCount % s.options.slidesToScroll !== 0 && i + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (i > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (i - s.slideCount)) * s.slideWidth * -1,
        n = (s.options.slidesToShow - (i - s.slideCount)) * t * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1,
        n = s.slideCount % s.options.slidesToScroll * t * -1))) : i + s.options.slidesToShow > s.slideCount && (s.slideOffset = (i + s.options.slidesToShow - s.slideCount) * s.slideWidth,
        n = (i + s.options.slidesToShow - s.slideCount) * t),
        s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0,
        n = 0),
        s.options.centerMode === !0 && s.options.infinite === !0 ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : s.options.centerMode === !0 && (s.slideOffset = 0,
        s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)),
        e = s.options.vertical === !1 ? i * s.slideWidth * -1 + s.slideOffset : i * t * -1 + n,
        s.options.variableWidth === !0 && (o = s.slideCount <= s.options.slidesToShow || s.options.infinite === !1 ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow),
        e = o[0] ? -1 * o[0].offsetLeft : 0,
        s.options.centerMode === !0 && (o = s.options.infinite === !1 ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow + 1),
        e = o[0] ? -1 * o[0].offsetLeft : 0,
        e += (s.$list.width() - o.outerWidth()) / 2)),
        e
    }
    ,
    e.prototype.getOption = e.prototype.slickGetOption = function(i) {
        var e = this;
        return e.options[i]
    }
    ,
    e.prototype.getNavigableIndexes = function() {
        var i, e = this, t = 0, o = 0, s = [];
        for (e.options.infinite === !1 ? (i = e.slideCount - e.options.slidesToShow + 1,
        e.options.centerMode === !0 && (i = e.slideCount)) : (t = -1 * e.slideCount,
        o = -1 * e.slideCount,
        i = 2 * e.slideCount); i > t; )
            s.push(t),
            t = o + e.options.slidesToScroll,
            o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }
    ,
    e.prototype.getSlick = function() {
        return this
    }
    ,
    e.prototype.getSlideCount = function() {
        var e, t, o, s = this;
        return o = s.options.centerMode === !0 ? s.slideWidth * Math.floor(s.options.slidesToShow / 2) : 0,
        s.options.swipeToSlide === !0 ? (s.$slideTrack.find(".slick-slide").each(function(e, n) {
            return n.offsetLeft - o + i(n).outerWidth() / 2 > -1 * s.swipeLeft ? (t = n,
            !1) : void 0
        }),
        e = Math.abs(i(t).attr("data-slick-index") - s.currentSlide) || 1) : s.options.slidesToScroll
    }
    ,
    e.prototype.goTo = e.prototype.slickGoTo = function(i, e) {
        var t = this;
        t.changeSlide({
            data: {
                message: "index",
                index: parseInt(i)
            }
        }, e)
    }
    ,
    e.prototype.init = function() {
        var e = this;
        i(e.$slider).hasClass("slick-initialized") || (i(e.$slider).addClass("slick-initialized"),
        e.buildOut(),
        e.setProps(),
        e.startLoad(),
        e.loadSlider(),
        e.initializeEvents(),
        e.updateArrows(),
        e.updateDots()),
        e.$slider.trigger("init", [e])
    }
    ,
    e.prototype.initArrowEvents = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.on("click.slick", {
            message: "previous"
        }, i.changeSlide),
        i.$nextArrow.on("click.slick", {
            message: "next"
        }, i.changeSlide))
    }
    ,
    e.prototype.initDotEvents = function() {
        var e = this;
        e.options.dots === !0 && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide),
        e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && e.options.autoplay === !0 && i("li", e.$dots).on("mouseenter.slick", function() {
            e.paused = !0,
            e.autoPlayClear()
        }).on("mouseleave.slick", function() {
            e.paused = !1,
            e.autoPlay()
        })
    }
    ,
    e.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(),
        e.initDotEvents(),
        e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler),
        e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler),
        e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler),
        e.$list.on("click.slick", e.clickHandler),
        e.options.autoplay === !0 && (i(document).on(e.visibilityChange, function() {
            e.visibility()
        }),
        e.options.pauseOnHover === !0 && (e.$list.on("mouseenter.slick", function() {
            e.paused = !0,
            e.autoPlayClear()
        }),
        e.$list.on("mouseleave.slick", function() {
            e.paused = !1,
            e.autoPlay()
        }))),
        e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler),
        e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on("orientationchange.slick.slick-" + e.instanceUid, function() {
            e.checkResponsive(),
            e.setPosition()
        }),
        i(window).on("resize.slick.slick-" + e.instanceUid, function() {
            i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
            e.windowDelay = window.setTimeout(function() {
                e.windowWidth = i(window).width(),
                e.checkResponsive(),
                e.setPosition()
            }, 50))
        }),
        i("*[draggable!=true]", e.$slideTrack).on("dragstart", function(i) {
            i.preventDefault()
        }),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
    }
    ,
    e.prototype.initUI = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(),
        i.$nextArrow.show()),
        i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show(),
        i.options.autoplay === !0 && i.autoPlay()
    }
    ,
    e.prototype.keyHandler = function(i) {
        var e = this;
        37 === i.keyCode && e.options.accessibility === !0 ? e.changeSlide({
            data: {
                message: "previous"
            }
        }) : 39 === i.keyCode && e.options.accessibility === !0 && e.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    e.prototype.lazyLoad = function() {
        function e(e) {
            i("img[data-lazy]", e).each(function() {
                var e = i(this)
                  , t = i(this).attr("data-lazy");
                e.load(function() {
                    e.animate({
                        opacity: 1
                    }, 200)
                }).css({
                    opacity: 0
                }).attr("src", t).removeAttr("data-lazy").removeClass("slick-loading")
            })
        }
        var t, o, s, n, l = this;
        l.options.centerMode === !0 ? l.options.infinite === !0 ? (s = l.currentSlide + (l.options.slidesToShow / 2 + 1),
        n = s + l.options.slidesToShow + 2) : (s = Math.max(0, l.currentSlide - (l.options.slidesToShow / 2 + 1)),
        n = 2 + (l.options.slidesToShow / 2 + 1) + l.currentSlide) : (s = l.options.infinite ? l.options.slidesToShow + l.currentSlide : l.currentSlide,
        n = s + l.options.slidesToShow,
        l.options.fade === !0 && (s > 0 && s--,
        n <= l.slideCount && n++)),
        t = l.$slider.find(".slick-slide").slice(s, n),
        e(t),
        l.slideCount <= l.options.slidesToShow ? (o = l.$slider.find(".slick-slide"),
        e(o)) : l.currentSlide >= l.slideCount - l.options.slidesToShow ? (o = l.$slider.find(".slick-cloned").slice(0, l.options.slidesToShow),
        e(o)) : 0 === l.currentSlide && (o = l.$slider.find(".slick-cloned").slice(-1 * l.options.slidesToShow),
        e(o))
    }
    ,
    e.prototype.loadSlider = function() {
        var i = this;
        i.setPosition(),
        i.$slideTrack.css({
            opacity: 1
        }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }
    ,
    e.prototype.next = e.prototype.slickNext = function() {
        var i = this;
        i.changeSlide({
            data: {
                message: "next"
            }
        })
    }
    ,
    e.prototype.pause = e.prototype.slickPause = function() {
        var i = this;
        i.autoPlayClear(),
        i.paused = !0
    }
    ,
    e.prototype.play = e.prototype.slickPlay = function() {
        var i = this;
        i.paused = !1,
        i.autoPlay()
    }
    ,
    e.prototype.postSlide = function(i) {
        var e = this;
        e.$slider.trigger("afterChange", [e, i]),
        e.animating = !1,
        e.setPosition(),
        e.swipeLeft = null,
        e.options.autoplay === !0 && e.paused === !1 && e.autoPlay()
    }
    ,
    e.prototype.prev = e.prototype.slickPrev = function() {
        var i = this;
        i.changeSlide({
            data: {
                message: "previous"
            }
        });
    }
    ,
    e.prototype.progressiveLazyLoad = function() {
        var e, t, o = this;
        e = i("img[data-lazy]", o.$slider).length,
        e > 0 && (t = i("img[data-lazy]", o.$slider).first(),
        t.attr("src", t.attr("data-lazy")).removeClass("slick-loading").load(function() {
            t.removeAttr("data-lazy"),
            o.progressiveLazyLoad(),
            o.options.adaptiveHeight === !0 && o.setPosition()
        }).error(function() {
            t.removeAttr("data-lazy"),
            o.progressiveLazyLoad()
        }));
    }
    ,
    e.prototype.refresh = function() {
        var e = this
          , t = e.currentSlide;
        e.destroy(),
        i.extend(e, e.initials),
        e.init(),
        e.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !0);
    }
    ,
    e.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
        e.slideCount = e.$slides.length,
        e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.options.focusOnSelect === !0 && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses(0),
        e.setPosition(),
        e.$slider.trigger("reInit", [e])
    }
    ,
    e.prototype.removeSlide = e.prototype.slickRemove = function(i, e, t) {
        var o = this;
        return "boolean" == typeof i ? (e = i,
        i = e === !0 ? 0 : o.slideCount - 1) : i = e === !0 ? --i : i,
        o.slideCount < 1 || 0 > i || i > o.slideCount - 1 ? !1 : (o.unload(),
        t === !0 ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
        o.$slides = o.$slideTrack.children(this.options.slide),
        o.$slideTrack.children(this.options.slide).detach(),
        o.$slideTrack.append(o.$slides),
        o.$slidesCache = o.$slides,
        void o.reinit())
    }
    ,
    e.prototype.setCSS = function(i) {
        var e, t, o = this, s = {};
        o.options.rtl === !0 && (i = -i),
        e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px",
        s[o.positionProp] = i,
        o.transformsEnabled === !1 ? o.$slideTrack.css(s) : (s = {},
        o.cssTransitions === !1 ? (s[o.animType] = "translate(" + e + ", " + t + ")",
        o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)",
        o.$slideTrack.css(s)))
    }
    ,
    e.prototype.setDimensions = function() {
        var i = this;
        if (i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
            padding: "0px " + i.options.centerPadding
        }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
        i.options.centerMode === !0 && i.$list.css({
            padding: i.options.centerPadding + " 0px"
        })),
        i.listWidth = i.$list.width(),
        i.listHeight = i.$list.height(),
        i.options.vertical === !1 && i.options.variableWidth === !1)
            i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow),
            i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length));
        else if (i.options.variableWidth === !0) {
            var e = 0;
            i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow),
            i.$slideTrack.children(".slick-slide").each(function() {
                e += i.listWidth
            }),
            i.$slideTrack.width(Math.ceil(e) + 1)
        } else
            i.slideWidth = Math.ceil(i.listWidth),
            i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length));
        var t = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        i.options.variableWidth === !1 && i.$slideTrack.children(".slick-slide").width(i.slideWidth - t);
        i.$slideTrack.children(".slick-slide").each(function() {
            var s = jQuery(this);
            var h = s.width() / s.data('aratio');
            s.height(h);
        });
    }
    ,
    e.prototype.setFade = function() {
        var e, t = this;
        t.$slides.each(function(o, s) {
            e = t.slideWidth * o * -1,
            t.options.rtl === !0 ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: 800,
                opacity: 0
            }) : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: 800,
                opacity: 0
            })
        }),
        t.$slides.eq(t.currentSlide).css({
            zIndex: 900,
            opacity: 1
        })
    }
    ,
    e.prototype.setHeight = function() {
        var i = this;
        if (1 === i.options.slidesToShow && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
        ;
    }
    ,
    e.prototype.setOption = e.prototype.slickSetOption = function(i, e, t) {
        var o = this;
        o.options[i] = e,
        t === !0 && (o.unload(),
        o.reinit())
    }
    ,
    e.prototype.setPosition = function() {
        var i = this;
        i.setDimensions(),
        i.setHeight(),
        i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
        i.$slider.trigger("setPosition", [i])
    }
    ,
    e.prototype.setProps = function() {
        var i = this
          , e = document.body.style;
        i.positionProp = i.options.vertical === !0 ? "top" : "left",
        "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
        (void 0 !== e.WebkitTransition || void 0 !== e.MozTransition || void 0 !== e.msTransition) && i.options.useCSS === !0 && (i.cssTransitions = !0),
        void 0 !== e.OTransform && (i.animType = "OTransform",
        i.transformType = "-o-transform",
        i.transitionType = "OTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.MozTransform && (i.animType = "MozTransform",
        i.transformType = "-moz-transform",
        i.transitionType = "MozTransition",
        void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
        void 0 !== e.webkitTransform && (i.animType = "webkitTransform",
        i.transformType = "-webkit-transform",
        i.transitionType = "webkitTransition",
        void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
        void 0 !== e.msTransform && (i.animType = "msTransform",
        i.transformType = "-ms-transform",
        i.transitionType = "msTransition",
        void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform && i.animType !== !1 && (i.animType = "transform",
        i.transformType = "transform",
        i.transitionType = "transition"),
        i.transformsEnabled = null !== i.animType && i.animType !== !1
    }
    ,
    e.prototype.setSlideClasses = function(i) {
        var e, t, o, s, n = this;
        n.$slider.find(".slick-slide").removeClass("slick-active").attr("aria-hidden", "true").removeClass("slick-center"),
        t = n.$slider.find(".slick-slide"),
        n.options.centerMode === !0 ? (e = Math.floor(n.options.slidesToShow / 2),
        n.options.infinite === !0 && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i,
        t.slice(o - e + 1, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
        0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
        n.$slides.eq(i).addClass("slick-center")) : i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow,
        o = n.options.infinite === !0 ? n.options.slidesToShow + i : i,
        n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
        "ondemand" === n.options.lazyLoad && n.lazyLoad()
    }
    ,
    e.prototype.setupInfinite = function() {
        var e, t, o, s = this;
        if (s.options.fade === !0 && (s.options.centerMode = !1),
        s.options.infinite === !0 && s.options.fade === !1 && (t = null,
        s.slideCount > s.options.slidesToShow)) {
            for (o = s.options.centerMode === !0 ? s.options.slidesToShow + 1 : s.options.slidesToShow,
            e = s.slideCount; e > s.slideCount - o; e -= 1)
                t = e - 1,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; o > e; e += 1)
                t = e,
                i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                i(this).attr("id", "")
            });
        }
        ;
    }
    ,
    e.prototype.selectHandler = function(e) {
        var t = this
          , o = parseInt(i(e.target).parents(".slick-slide").attr("data-slick-index"));
        return o || (o = 0),
        t.slideCount <= t.options.slidesToShow ? (t.$slider.find(".slick-slide").removeClass("slick-active").attr("aria-hidden", "true"),
        t.$slides.eq(o).addClass("slick-active").attr("aria-hidden", "false"),
        t.options.centerMode === !0 && (t.$slider.find(".slick-slide").removeClass("slick-center"),
        t.$slides.eq(o).addClass("slick-center")),
        void t.asNavFor(o)) : void t.slideHandler(o)
    }
    ,
    e.prototype.slideHandler = function(i, e, t) {
        var o, s, n, l, r = null, d = this;
        return e = e || !1,
        d.animating === !0 && d.options.waitForAnimate === !0 || d.options.fade === !0 && d.currentSlide === i || d.slideCount <= d.options.slidesToShow ? void 0 : (e === !1 && d.asNavFor(i),
        o = i,
        r = d.getLeft(o),
        l = d.getLeft(d.currentSlide),
        d.currentLeft = null === d.swipeLeft ? l : d.swipeLeft,
        d.options.infinite === !1 && d.options.centerMode === !1 && (0 > i || i > d.getDotCount() * d.options.slidesToScroll) ? void (d.options.fade === !1 && (o = d.currentSlide,
        t !== !0 ? d.animateSlide(l, function() {
            d.postSlide(o)
        }) : d.postSlide(o))) : d.options.infinite === !1 && d.options.centerMode === !0 && (0 > i || i > d.slideCount - d.options.slidesToScroll) ? void (d.options.fade === !1 && (o = d.currentSlide,
        t !== !0 ? d.animateSlide(l, function() {
            d.postSlide(o)
        }) : d.postSlide(o))) : (d.options.autoplay === !0 && clearInterval(d.autoPlayTimer),
        s = 0 > o ? d.slideCount % d.options.slidesToScroll !== 0 ? d.slideCount - d.slideCount % d.options.slidesToScroll : d.slideCount + o : o >= d.slideCount ? d.slideCount % d.options.slidesToScroll !== 0 ? 0 : o - d.slideCount : o,
        d.animating = !0,
        d.$slider.trigger("beforeChange", [d, d.currentSlide, s]),
        n = d.currentSlide,
        d.currentSlide = s,
        d.setSlideClasses(d.currentSlide),
        d.updateDots(),
        d.updateArrows(),
        d.options.fade === !0 ? (t !== !0 ? d.fadeSlide(s, function() {
            d.postSlide(s)
        }) : d.postSlide(s),
        void d.animateHeight()) : void (t !== !0 ? d.animateSlide(r, function() {
            d.postSlide(s)
        }) : d.postSlide(s))));
    }
    ,
    e.prototype.startLoad = function() {
        var i = this;
        i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(),
        i.$nextArrow.hide()),
        i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
        i.$slider.addClass("slick-loading")
    }
    ,
    e.prototype.swipeDirection = function() {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX,
        e = s.touchObject.startY - s.touchObject.curY,
        t = Math.atan2(e, i),
        o = Math.round(180 * t / Math.PI),
        0 > o && (o = 360 - Math.abs(o)),
        45 >= o && o >= 0 ? s.options.rtl === !1 ? "left" : "right" : 360 >= o && o >= 315 ? s.options.rtl === !1 ? "left" : "right" : o >= 135 && 225 >= o ? s.options.rtl === !1 ? "right" : "left" : "vertical";
    }
    ,
    e.prototype.swipeEnd = function(i) {
        var e, t = this;
        if (t.dragging = !1,
        t.shouldClick = t.touchObject.swipeLength > 10 ? !1 : !0,
        void 0 === t.touchObject.curX)
            return !1;
        if (t.touchObject.edgeHit === !0 && t.$slider.trigger("edge", [t, t.swipeDirection()]),
        t.touchObject.swipeLength >= t.touchObject.minSwipe) {
            var o = t.swipeDirection();
            switch (o) {
            case "left":
                e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide + t.getSlideCount()) : t.currentSlide + t.getSlideCount(),
                t.slideHandler(e),
                t.currentDirection = 0,
                t.touchObject = {},
                t.$slider.trigger("swipe", [t, "left"]);
                break;
            case "right":
                e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide - t.getSlideCount()) : t.currentSlide - t.getSlideCount(),
                t.slideHandler(e),
                t.currentDirection = 1,
                t.touchObject = {},
                t.$slider.trigger("swipe", [t, "right"]);
            }
        } else if (Math.abs(t.touchObject.swipeVerticalLength) >= t.touchObject.minSwipe) {
            var o = t.swipeDirection();
            "vertical" == o && t.touchObject.swipeVerticalLength < 0 && (t.touchObject = {},
            "function" == typeof t.options.swipeUpAction && t.options.swipeUp())
        } else
            t.touchObject.startX !== t.touchObject.curX && (t.slideHandler(t.currentSlide),
            t.touchObject = {})
    }
    ,
    e.prototype.swipeHandler = function(i) {
        var e = this;
        if (!(e.options.swipe === !1 || "ontouchend"in document && e.options.swipe === !1 || e.options.draggable === !1 && -1 !== i.type.indexOf("mouse")))
            switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1,
            e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
            i.data.action) {
            case "start":
                e.swipeStart(i);
                break;
            case "move":
                e.swipeMove(i);
                break;
            case "end":
                e.swipeEnd(i);
            }
    }
    ,
    e.prototype.swipeMove = function(i) {
        var e, t, o, s, n, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null,
        !l.dragging || n && 1 !== n.length ? !1 : (e = l.getLeft(l.currentSlide),
        l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX,
        l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY,
        l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))),
        t = l.swipeDirection(),
        "vertical" === t ? void (l.touchObject.swipeVerticalLength = l.touchObject.curY - l.touchObject.startY) : (void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && i.preventDefault(),
        s = (l.options.rtl === !1 ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1),
        o = l.touchObject.swipeLength,
        l.touchObject.edgeHit = !1,
        l.options.infinite === !1 && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction,
        l.touchObject.edgeHit = !0),
        l.options.vertical === !1 ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s,
        l.options.fade === !0 || l.options.touchMove === !1 ? !1 : l.animating === !0 ? (l.swipeLeft = null,
        !1) : void l.setCSS(l.swipeLeft)));
    }
    ,
    e.prototype.swipeStart = function(i) {
        var e, t = this;
        return 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? (t.touchObject = {},
        !1) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
        t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX,
        t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY,
        void (t.dragging = !0))
    }
    ,
    e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
        var i = this;
        null !== i.$slidesCache && (i.unload(),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slidesCache.appendTo(i.$slideTrack),
        i.reinit())
    }
    ,
    e.prototype.unload = function() {
        var e = this;
        i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow && "object" != typeof e.options.prevArrow && e.$prevArrow.remove(),
        e.$nextArrow && "object" != typeof e.options.nextArrow && e.$nextArrow.remove(),
        e.$slides.removeClass("slick-slide slick-active slick-visible").attr("aria-hidden", "true").css("width", "");
    }
    ,
    e.prototype.unslick = function() {
        var i = this;
        i.destroy();
    }
    ,
    e.prototype.updateArrows = function() {
        var i, e = this;
        i = Math.floor(e.options.slidesToShow / 2),
        e.options.arrows === !0 && e.options.infinite !== !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.removeClass("slick-disabled"),
        e.$nextArrow.removeClass("slick-disabled"),
        0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled"),
        e.$nextArrow.removeClass("slick-disabled")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && e.options.centerMode === !1 ? (e.$nextArrow.addClass("slick-disabled"),
        e.$prevArrow.removeClass("slick-disabled")) : e.currentSlide >= e.slideCount - 1 && e.options.centerMode === !0 && (e.$nextArrow.addClass("slick-disabled"),
        e.$prevArrow.removeClass("slick-disabled")));
    }
    ,
    e.prototype.updateDots = function() {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
        i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
    }
    ,
    e.prototype.visibility = function() {
        var i = this;
        document[i.hidden] ? (i.paused = !0,
        i.autoPlayClear()) : (i.paused = !1,
        i.autoPlay());
    }
    ,
    i.fn.slick = function() {
        var i, t = this, o = arguments[0], s = Array.prototype.slice.call(arguments, 1), n = t.length, l = 0;
        for (l; n > l; l++)
            if ("object" == typeof o || "undefined" == typeof o ? t[l].slick = new e(t[l],o) : i = t[l].slick[o].apply(t[l].slick, s),
            "undefined" != typeof i)
                return i;
        return t;
    }
    ,
    i(function() {
        i("[data-slick]").slick();
    })
});
(function($) {
    $.event.special.doubletap = {
        bindType: 'touchend',
        delegateType: 'touchend',
        handle: function(event) {
            var handleObj = event.handleObj
              , targetData = jQuery.data(event.target)
              , now = new Date().getTime()
              , delta = targetData.lastTouch ? now - targetData.lastTouch : 0
              , delay = delay == null ? 300 : delay;
            if (delta < delay && delta > 30) {
                targetData.lastTouch = null;
                event.type = handleObj.origType;
                ['clientX', 'clientY', 'pageX', 'pageY'].forEach(function(property) {
                    event[property] = event.originalEvent.changedTouches[0][property];
                })
                handleObj.handler.apply(this, arguments);
            } else {
                targetData.lastTouch = now;
            }
        }
    };
}
)(jQuery);


;(function($, undefined) {
    'use strict';

    app.initResizer = function() {

        $(window).smartresize(function() {
            //console.log("sss")
            app.w = document.documentElement.clientWidth;
            app.isMobile = app.w < 768;
            app.isTablet = app.w < 1024 && app.w >= 768;
        });

       
    };
})(jQuery);

// initHomeCarousel
;(function($, undefined) {
    'use strict';

    app.initHomeCarousel = function() {
        $('.home-carousel').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 5000
        });
    }
    ;

    app.initHomeProductCarousel = function() {
        $('.home-product-carousel').slick({
            dots: false,
            infinite: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 10000,
            slidesToShow: 6,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 820,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 560,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }]
        });
    }
    ;
  
  app.initHomeBrandCarousel = function() {
        $('.home-brand-carousel').slick({
            dots: false,
            infinite: true,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1,
                  centerMode: true,
                    slidesToScroll: 1
                  
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 820,
                settings: {
                    slidesToShow: 1,
                  dots: false,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                  dots: false,
                    slidesToScroll: 1
                }
            }]
        });
    }
    ;

}
)(jQuery);

// initMobileMenuFooterToggles
// Function: Shows and hides category children
;(function($, undefined) {
    'use strict';

    app.initMobileMenuFooterToggles = function() {
        // Hide/show sitemap links in footer for mobile
        $('#nav-mobile li.parent .childMenuToggle, #nav-mobile-plus li.parent .childMenuToggle').on('click', function() {
            $(this).siblings('ul').toggle();
            $(this).toggleClass('open');
        });
    }
    ;
}
)(jQuery);

// initProductCarousel
;(function($, undefined) {
    'use strict';

    app.initProductCarousel = function() {
        //console.log("uuuuu",app.isMobile)
        var productSlider = $('.product-view .more-views ul');
        var productSliderItems = $('.product-view .more-views ul li');

        function slickProductSlider() {
          
          	productSlider.on('init', function() {
                var nSlideImg = $(this).find('li.slick-active img');
               	nSlideImg.attr('src', nSlideImg.data('pclazy'));
            });
          
            productSlider.slick({
              	lazyLoad: 'ondemand',
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            });

            // Product carousel event delegation

            

            productSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              	var nSlideImg = $(slick.$slides.get(nextSlide)).find('img');
              	nSlideImg.attr('src', nSlideImg.data('pclazy'));
                $(this).find('li img').css('height','auto');
            });
        }

        if($(window).width() < 767){
            slickProductSlider();
            productSliderItems.children('a').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
            app.productIsSlicked = true;
        }else{
         	$("#mediablock ul li img").css('height','auto');
        }

        $(window).smartresize(function() {
            if (app.isMobile && !app.productIsSlicked) {
                slickProductSlider();
                productSliderItems.children('a').on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                })
            } else if (!app.isMobile) {
              	if(app.productIsSlicked)
               		productSlider.slick('unslick');
              	$("#mediablock img[data-pclazy]").each(function(){
                  	$(this).attr('src', $(this).data('pclazy'));
                });
              	$("#mediablock ul li img").css('height','auto');
            }
        });


    }
}
)(jQuery);


/* top link country */
jQuery(function(){
    jQuery("#top-link-country").hover(function(){ 
        jQuery(this).children().fadeIn(300);
    },function(){
        jQuery(this).children('a').hide();
    });
});


// Mobile Menu class functions
;(function($, undefined) {
    'use strict';

    app.MobileMenu = function() {
        var self = this;

        this.isOpen = false;
        this.isBusy = false;

        // Setup actions for opening/closing mobile menu
        // NOTE: These functions require that their reverse
        //       be put into the this.close function
        this.open = function() {
            self.isBusy = true;

            $('#content-mask').show();
            
            $('body, html').addClass('no-scroll');
            if (app.isMobile){
                $('#wrapper').addClass('slideTo75').addClass('gestureClose');
            } else if (app.isTablet){
                $('#wrapper').addClass('slideTo35').addClass('gestureClose');
            }
            $('#off-canvas-left').addClass('slideTo0');

            if (app.hasStickyHeader){
                $('.sticky-header').addClass('slideTo75').addClass('gestureClose');
            }

            self.isOpen = true;

            setTimeout(function() {
                self.isBusy = false;
            }, 350);
        };

        this.close = function() {
            self.isBusy = true;

            $('#content-mask').hide();
            $('body, html').removeClass('no-scroll');
            if (app.isMobile){
                $('#wrapper').removeClass('slideTo75').removeClass('gestureClose');
            } else if (app.isTablet){
                $('#wrapper').removeClass('slideTo35').removeClass('gestureClose');
            }
            $('#off-canvas-left').removeClass('slideTo0');

            if (app.hasStickyHeader){
                $('.sticky-header').removeClass('slideTo75').removeClass('gestureClose');
            }

            self.isOpen = false;

            setTimeout(function() {
                self.isBusy = false;
            }, 350);
        };

        this.toggle = function(e) {
            if (!self.isBusy) {
                if (self.isOpen) {
                    e.preventDefault();
                    self.close();
                } else {
                    e.preventDefault();
                    self.open();
                }
            }
        };

        this.init = function() {

            // Hide/show sitemap links in footer for mobile
            $('.menu-icon-wrap').on('click', self.toggle);
            $("#content-mask").on('click',function(){$('.menu-icon-wrap').click()});
        };

        this.init()
    };
})(jQuery);


jQuery(function(){
    jQuery(document).on("click", ".search-trigger, .search-trigger-desktop", function(){
        if(jQuery(".search-bar").is(":visible")){
            jQuery(".search-bar").hide();
        }else{
            jQuery(".search-bar").show();
            jQuery(".search-bar #search").focus();
        }
    });
});



$(document).ready(function(){
  $( ".search-icon-desktop" ).click(function() {
    $( "#search_mini_form" ).submit();
  });
});


$(document).ready(function(){
  
  
  if (ActualPathName.indexOf("price") > -1) { 
    $(".filter-options-wrapper-price").addClass("always-display");
    $(".price-filter-toggle").removeClass("icon-down-arrow"); 
  }else if (ActualPathName.indexOf("size") > -1) { 
    $(".filter-options-wrapper-size").addClass("always-display");
    $(".size-filter-toggle").removeClass("icon-down-arrow"); 
  }else if (ActualPathName.indexOf("colour") > -1) { 
    $(".filter-options-wrapper-colour").addClass("always-display");
    $(".color-filter-toggle").removeClass("icon-down-arrow"); 
  }else if (ActualPathName.indexOf("col_nsid") > -1) { 
    $(".filter-options-wrapper-brand").addClass("always-display");
    $(".brand-filter-toggle").removeClass("icon-down-arrow"); 
  }
  
  $('.filter-container .active-category').remove().prependTo('.filter-container');
  
  $( ".filter-btn" ).click(
    function() {
      $(".filter-block").toggle();
    }
  );
  
  
  $( ".size-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-size").slideToggle();
      $(".size-filter-toggle").toggleClass("icon-down-arrow");
      $(".size-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".brand-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-brand").slideToggle();
      $(".brand-filter-toggle").toggleClass("icon-down-arrow");
      $(".brand-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  
  $( ".feature-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-feature").slideToggle();
      $(".feature-filter-toggle").toggleClass("icon-down-arrow");
      $(".feature-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
 
  
  $( ".width-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-width").slideToggle();
      $(".width-filter-toggle").toggleClass("icon-down-arrow");
      $(".width-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".girth-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-girth").slideToggle();
      $(".girth-filter-toggle").toggleClass("icon-down-arrow");
      $(".girth-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".insertableLength-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-insertableLength").slideToggle();
      $(".insertableLength-filter-toggle").toggleClass("icon-down-arrow");
      $(".insertableLength-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  
  $( ".material-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-material").slideToggle();
      $(".material-filter-toggle").toggleClass("icon-down-arrow");
      $(".material-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  
  $( ".powerSource-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-powerSource").slideToggle();
      $(".powerSource-filter-toggle").toggleClass("icon-down-arrow");
      $(".powerSource-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".length-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-length").slideToggle();
      $(".length-filter-toggle").toggleClass("icon-down-arrow");
      $(".length-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".color-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-colour").slideToggle();
      $(".color-filter-toggle").toggleClass("icon-down-arrow");
      $(".color-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".style-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-style").slideToggle();
      $(".style-filter-toggle").toggleClass("icon-down-arrow");
      $(".style-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".price-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-price").slideToggle();
      $(".price-filter-toggle").toggleClass("icon-down-arrow");
      $(".price-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".vibrator-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-vibrators").slideToggle();
      $(".vibrator-filter-toggle").toggleClass("icon-down-arrow");
      $(".vibrator-filter-toggle").toggleClass("icon-up-arrow");
    }
  );

  $( ".dildo-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-dildos").slideToggle();
      $(".dildo-filter-toggle").toggleClass("icon-down-arrow");
      $(".dildo-filter-toggle").toggleClass("icon-up-arrow");
    }
  );

  $( ".lubes-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-lubes").slideToggle();
      $(".lubes-filter-toggle").toggleClass("icon-down-arrow");
      $(".lubes-filter-toggle").toggleClass("icon-up-arrow");
    }
  );

  $( ".man-cave-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-man-cave").slideToggle();
      $(".man-cave-filter-toggle").toggleClass("icon-down-arrow");
      $(".man-cave-filter-toggle").toggleClass("icon-up-arrow");
    }
  );

  $( ".couples-filter-toggle" ).click(
    function() {
      $(".filter-options-wrapper-couples").slideToggle();
      $(".couples-filter-toggle").toggleClass("icon-down-arrow");
      $(".couples-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
 
  
  $( ".mobile-cata-filter-toggle" ).click(
    function() {
      $(".mobile-cata-filter-toggle").toggleClass("icon-down-arrow");
      $(".mobile-cata-filter-toggle").toggleClass("icon-up-arrow");
    }
  );
  
  $( ".size-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-size").slideToggle();
      $(".size-mobile-filter").toggleClass("icon-plus");
      $(".size-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".lingerie-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-lingerie").slideToggle();
      $(".lingerie-mobile-filter").toggleClass("icon-plus");
      $(".lingerie-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".style-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-style").slideToggle();
      $(".style-mobile-filter").toggleClass("icon-plus");
      $(".style-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".width-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-width").slideToggle();
      $(".width-mobile-filter").toggleClass("icon-plus");
      $(".width-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".feature-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-feature").slideToggle();
      $(".feature-mobile-filter").toggleClass("icon-plus");
      $(".feature-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".material-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-material").slideToggle();
      $(".material-mobile-filter").toggleClass("icon-plus");
      $(".material-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".insertableLength-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-insertableLength").slideToggle();
      $(".insertableLength-mobile-filter").toggleClass("icon-plus");
      $(".insertableLength-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".length-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-length").slideToggle();
      $(".length-mobile-filter").toggleClass("icon-plus");
      $(".length-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".girth-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-girth").slideToggle();
      $(".girth-mobile-filter").toggleClass("icon-plus");
      $(".girth-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  
  
  $( ".powerSource-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-powerSource").slideToggle();
      $(".powerSource-mobile-filter").toggleClass("icon-plus");
      $(".powerSource-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".male-enhance-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-male-enhance").slideToggle();
      $(".male-enhance-mobile-filter").toggleClass("icon-plus");
      $(".male-enhance-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".sensual-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-sensual").slideToggle();
      $(".sensual-mobile-filter").toggleClass("icon-plus");
      $(".sensual-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".price-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-price").slideToggle();
      $(".price-mobile-filter").toggleClass("icon-plus");
      $(".price-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".color-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-colour").slideToggle();
      $(".color-mobile-filter").toggleClass("icon-plus");
      $(".color-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".dildo-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-dildos").slideToggle();
      $(".dildo-mobile-filter").toggleClass("icon-plus");
      $(".dildo-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".vibrator-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-vibrators").slideToggle();
      $(".vibrator-mobile-filter").toggleClass("icon-plus");
      $(".vibrator-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".anal-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-anal").slideToggle();
      $(".anal-mobile-filter").toggleClass("icon-plus");
      $(".anal-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".lubes-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-lubes").slideToggle();
      $(".lubes-mobile-filter").toggleClass("icon-plus");
      $(".lubes-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".bondage-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-bondage").slideToggle();
      $(".bondage-mobile-filter").toggleClass("icon-plus");
      $(".bondage-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".male-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-man-cave").slideToggle();
      $(".male-mobile-filter").toggleClass("icon-plus");
      $(".male-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $( ".brand-mobile-filter" ).click(
    function() {
      $(".filter-options-wrapper-brand").slideToggle();
      $(".brand-mobile-filter").toggleClass("icon-plus");
      $(".brand-mobile-filter").toggleClass("icon-minus");
    }
  );
  
  $(".shippingAlertMessage").click(function(){
    $(".shipping-message-hover").toggle();
  });
  
  $(".shippingMessageHeader").click(function(){
    $(".shipping-message-hover").toggle();
  });
  
  
});




//product size link
jQuery(function(){
  var sizes = $(".combiner-link input");
  sizes.click(function(){
    var pInfo = $(this).data('pinfo').split("%%");
    //console.log(pInfo[6]);
    $("#Variant-Specs").html(pInfo[5]);
    $("#ProductPrice-product-template").text(pInfo[1]);

    var LoyaltyPrice = Math.round(pInfo[8]/100)*10;
   

    $("#loyaltyPriceChange").text(LoyaltyPrice);
    $(".sku").text(pInfo[0]);
    $(".mpn").text(pInfo[4]);
    $(".upc").text(pInfo[3]);
    $(".inventory").text(pInfo[6]);
    
    $(".productPriceWholesale").text(pInfo[1]);
    
    
    var regVariantPrice = (pInfo[9]/100)
    
    
    $(".RegVariantPrice").text(pInfo[9]);
    
    $(".compare_at_price").text(pInfo[11]);
    
    if(pInfo[10] == 1){
      $(".discountWholesalePrice").css("display", "inline-block");
    } else {
    	$(".discountWholesalePrice").css("display", "none");
    }
    
    console.log(regVariantPrice);
    
    //$(".discoTag").text(pInfo[7]);
    if(pInfo[7] == "true"){
        $(".inventory").addClass("discoTag");
    }
    
    var sku = pInfo[0];
    var stock = $(this).data('stock');
    $(this).closest('form').find('.notify-button').hide();
    if(stock == 'in'){
      $(this).closest('form').find('.product-single__add-to-cart').show();
    }else{
      $(this).closest('form').find('.product-single__add-to-cart').hide();
      $(this).closest('form').find('#notify_'+sku).show();
    }
    
  });
  var defaultVariant = sizes.filter("[checked]");
  if(defaultVariant.length > 0)
  	defaultVariant.trigger('click');
  else{
    sizes.filter(":first").trigger('click');
  }
});



$(document).ready(function() {

    $('#popup-close').click(function(e) // You are clicking the close button
    {
    $('#popup').toggle(); // Now the pop up is hiden.
    });
    $('#popup-background').click(function(e) 
    {
    $('#popup').toggle(); 
    });
});


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//**************** For testing purposes switch country_code to CA. By default it's US ****************
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function goCountryPopup(){
	var status = getCookie('CountryPopup');
	if(status == "Shown" || !locationInfo) return;
	if (locationInfo.country_code === 'CA') {
      // Tell them about the Canadian store.
      var status = getCookie('CountryPopup');
      if(status == "Shown"){
        //alert("free gift removed");
        //console.log("1-Country");
        //$('#popup').toggle(); 
      }else {
        //alert("free gift added to cart");
        //console.log("2-Country");
        $("#CountryPopup").delay(2000).fadeIn(); 
        var d = new Date();
        var cname = "CountryPopup";
        var cvalue = "Shown";
        d.setDate(d.getDate() + 1);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
      }

    } else {
      var status = getCookie('popup');
      if(status == "Shown"){
        //alert("free gift removed");
        //console.log("1-Newsletter");
        //$('#popup').toggle(); 
      }else {
        //alert("free gift added to cart");
        //console.log("2-Newsletter");
        $("#popup").delay(2000).fadeIn(); 
        var d = new Date();
        var cname = "popup";
        var cvalue = "Shown";
        d.setDate(d.getDate() + 1);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";


      }
    }
}

function checkAffiliate(){
	
	var affId = getCookie('affId');
	if(affId){
		$("body").append("<span id='idevaffiliate' style='display:none'>Aff. Id: "+affId+"</span>");
	}else{
		affId = getParameterByName('affiliateid');
		if(!affId) affId = 1001;

		$("body").append('<span id="idevaffiliate"><img src="https://www.pinkcherryaffiliate.com/sextoys.php?ip_address='+locationInfo.ip+'&amp;id='+affId+'" border="0" width="1" height="1"/></span>');


		var d = new Date();
	   var cname = "affId";
	   var cvalue = affId;
	   d.setDate(d.getDate() + 1);
	   var expires = "expires=" + d.toGMTString();
	   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
		
	}
}


var locationInfo = null;
$(document).ready(function() {
	locationInfo = getCookie('locationInfo');
	if(!locationInfo){
		jQuery.ajax( {
		  url: '//tools.tbmbm.net/geo/',
		  type: 'POST',
		  dataType: 'jsonp',
		  success: function(location) {
		  		locationInfo = location;

				var d = new Date();
				var cname = "locationInfo";
				var cvalue = JSON.stringify(locationInfo);
				d.setDate(d.getDate() + 1);
				var expires = "expires=" + d.toGMTString();
				document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure";
				goCountryPopup();
				checkAffiliate();
		  }
		});
	}else{
		try{
          locationInfo = JSON.parse(locationInfo);
          goCountryPopup();
	 	}catch(err){}
	}
});




$(document).ready(function(){
$( "#quick-view-background" ).click(
    function() {
      $("#ImageViewer").toggle();
    }
  );
});




window.imageViewInited = false;
function showImageViewer(callback){
  if(!window.imageViewInited){
    jQuery('#ImageViewer img').each(function(){
        var limg = $(this).attr('viewer-lazy');
        if (typeof limg !== typeof undefined && limg !== false) {
           $(this).attr('src', limg);
           $(this).removeAttr('data-lazy');
        }
    });
    setTimeout(function(){imageresize();}, 500);
    $(window).bind("resize", function(){
        imageresize();
        divresize();
    });

    
    imageresize();
    divresize();
    
    $(document).keyup(function(e) {
      if (e.keyCode == 27) { jQuery('#ImageViewer').toggle(); }   
    });
    
  }
  
  
  if(callback){
    if(!window.imageViewInited){
    	setTimeout(function(){ jQuery('#ImageViewer').toggle(); callback() }, 500);
    }else{
    	jQuery('#ImageViewer').toggle(); 
    }
  }else{
   	jQuery('#ImageViewer').toggle(); 
  }
  
  window.imageViewInited = true;
}
  

$(document).ready(function() {
  	var bLazy = new Blazy();
  
  
  
    if($(window).width() > 767){
        $("#mediablock img").each(function(){
        var limg = $(this).attr('data-lazy');
        if (typeof limg !== typeof undefined && limg !== false) {
           $(this).attr('src', limg);
           $(this).removeAttr('data-lazy');
        }
        });
    }	
  
  	if($(window).width() > 767){
      if($("#mediablock").length > 0){
        $("#mediablock img[data-pclazy]").each(function(){
          $(this).attr('src', $(this).data('pclazy'));
        });
      }
    }
});

// init
;(function($, undefined) {
    'use strict';

    // fix prototype console hack (comment out for production)
    // WARNING: This fix breaks iOS js when used with console.logs
    //delete window.console;

    $(function(){
        app.init = function() {
            // Initialize events
            app.initResizer();
            app.initHomeCarousel();
          app.initHomeBrandCarousel();
            app.initHomeProductCarousel();
            app.initProductCarousel();
            app.initMobileMenuFooterToggles();
            
            app.mobileMenu = new app.MobileMenu();

             $(window).trigger("resize");
        };
    
        app.init();
    });
  
  $(document).ready(function(){
  $(".headerReviewText").click(function() {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".review-form-container").offset().top
    }, 750);
  });

});

$(document).ready(function(){
  $(".headerReviews").click(function() {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".info-section-content-reviews").offset().top
    }, 750);
  });

});
  
})(jQuery);


function productAdd2CartFormSizeChange(sel){
  var selVar = $(sel).find(":selected");
  var sku = selVar.data('sku');
  var stock = selVar.data('stock');
  $(sel).closest('form').find('.notify-button').hide();
  if(stock == 'in'){
    $(sel).closest('form').find('.quantity, .add-to-cart__wrapper').show();
  }else{
    $(sel).closest('form').find('.quantity, .add-to-cart__wrapper').hide();
    $(sel).closest('form').find('#notify_'+sku).show();
  }
}







$(function(){
  var currentRequest = null; 
  var noResultTerms = [];
  var searchData = [];
  var stopSubmitSearch = false;
  
  $("#search_mini_form").on('submit', function(event){
    $(this).attr('action', '/search');
    if(stopSubmitSearch) return false;
    var input = $(this).find('.pc_s');
    var term = $.trim(input.val().replace(/\s\s+/g, ' '));
    input.val(term.replace(/\s/g, " OR "));
    setTimeout(function(){ input.val(term); }, 50);
  });
  $("#search_mini_form .pc_s").keypress(function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if(keycode == '13' && searchData.result.length > 0){    
      var term = $.trim($(this).val());
      for(i in searchData.result){
        var syns = searchData.result[i].syn.split(",").map(k => $.trim(k.toLowerCase()));
        term = term.toLowerCase();
        if(term == searchData.result[i].k.toLowerCase() || syns.includes(term)){	
          stopSubmitSearch = true; 
          window.location.href = searchData.result[i].url;
          break;
        }
      }
    }
  });
  
  $(document).on("click", function(event){
    var $trigger = $("#search_mini_form");
    if(!$trigger.is($(event.target)) && $trigger.has($(event.target)).length == 0){
      $(".search_dropdown").hide();
    }            
  });
  console.log($(".pc_s").length);
  $(".pc_s").on('focus', function(){
    var dropdown = $(this).closest('#search_mini_form').find('.search_dropdown');
    if(dropdown.find("ul li").length > 0) dropdown.show();

  }).on('paste keyup', function(){
    var term = $.trim($(this).val());
    var dropdown = $(this).closest('#search_mini_form').find('.search_dropdown');
    if(term.length < 2){
      dropdown.find("ul").empty();
      dropdown.hide();
      if(currentRequest != null) {
        currentRequest.abort();
        searchData = [];
      }  
      return;
    }

    if(currentRequest != null) {
      currentRequest.abort();
    }

    
    for(s in noResultTerms){
      if(term.indexOf(noResultTerms[s]) == 0){
        var resultHtml = '<ul>';
        resultHtml += "<li class='searchfor'><a href='javascript:;' class='basic_search'>Search for \""+$('<span></span>').text(term).html()+"\".</a></li>";
        resultHtml += "</ul>";
        dropdown.empty().html(resultHtml).show();
        return; 
      }
    }

    currentRequest = jQuery.ajax({
      type: 'GET',
      data: 's=' + encodeURIComponent(term)+"&market=us_ws",
      url: 'https://tools.tbmbm.net/search/',
      beforeSend : function()    {           
        if(currentRequest != null) {
          currentRequest.abort();
        }
      },
      success: function(data) {
        var count = 0;
        if(data.result.length == 0) noResultTerms.push(term);
        var resultHtml = '<ul>';
        resultHtml += "<li class='searchfor'><a href='javascript:;' class='basic_search'>Search for \""+$('<span></span>').text(term).html()+"\".</a></li>";
        var resultRowsCat = [];
        var resultRowsBrand = [];
        searchData = data;
        for(i in data.result){
          count++;
          var d = data.result[i];
          if(d.t=='category')
            resultRowsCat.push(formatResultRow(d,term));
          if(d.t=='brand')
            resultRowsBrand.push(formatResultRow(d,term));

        }
        if(resultRowsBrand.length > 0){
          resultHtml += resultRowsBrand.reverse().join('\n');
          resultHtml += '<li class="search_brands">Brands</li>';
        }
        if(resultRowsCat.length > 0){
          resultHtml += resultRowsCat.reverse().join('\n');
          resultHtml += '<li class="search_cats">Categories</li>';
        }

        resultHtml += "</ul>";
        dropdown.empty().html(resultHtml).show();

        $(".search_dropdown ul").width(dropdown.closest('.form-search').width()-50);


      },
      error:function(e){
      }
    });
  });
  
  $(document).on('click', ".basic_search", function(){
    $(this).closest('.pc_s_form').trigger('submit');
  });
});
function formatResultRow(o,term){
  return '<li><a href="'+o.url+'">'+o.k.replace(term,"<strong>"+term+"</strong>")+'</a></li>';
}




/* search begin */
/*
var isp_renderedCalled = false;
var __isp_options = {
   isp_serp_callback: function () {
     			//if(window.isp_renderedCalled) return;
     			//isp_renderedCalled = true;
     			var sellableProducts = [];
     
                if($('.isp_grid_product').first().data('tbmbm-processed')){
                  console.log('callback duplicate call');
                  return;
                }else{
                  console.log("callback");
                }

				$('.isp_grid_product').each(function (index) {
                  	$(this).data('tbmbm-processed',1);
					var isp_variants_options = new Object;
					var p_id = $(this).attr('product_id');
					var p_p = $(this).attr('product_p_min');
                  	var p_data = ISP_PRODUCTS[p_id];
					var variant_data = p_data.vra;
					
                  
                  	// platinum price?
                  	var price_wrapper = $(this).find('.isp_product_price');
					var product_price = parseFloat(price_wrapper.data('currency-cad'));
                  	var priceWrapperNewContent = '';
                  	if(tbmbmCustGroup == 'Platinum'){
                    	var p_tags = [];
                      	for(var i=0; i<p_data.att.length;i++){
                          	if(p_data.att[i][0] == 'Tag') p_tags = p_data.att[i][1];
                        }
                      	var nonPlatinumP = p_tags.indexOf('non-platinum') == -1 ? false: true;
                      	if(!nonPlatinumP){
                          	wholesale_price = product_price;
                        	platinum_price = wholesale_price * 0.9;
                          	platinum_price = platinum_price.toFixed(2);
                            price_wrapper.data('currency-cad', product_price);
                          	priceWrapperNewContent = '<s>$'+wholesale_price+'</s>(10%) <span style="color:red">Platinum: \$'+platinum_price+'</span><br>';
                        }else{
                          priceWrapperNewContent = price_wrapper.html()+"<br>";
                        }
                      
                    }else{
                      if(window.tbmbmCustId)
                      	priceWrapperNewContent = price_wrapper.html()+"<br>";
                      else{
                        priceWrapperNewContent = '';
                        $(this).find(".isp_product_price_wrapper").remove();
                      }
                    }
                  
                  	// re-build add to cart
                  	var add_form = $(this).find('.isp_add_to_cart_form');
                  	var new_form = '<form method="post" class="product-form isp_add_to_cart_form">'
                    var notify_html = '';
                  	if(variant_data.length == 1){
                  		new_form += '<input type="hidden" id="variant-select" name="id" value="'+variant_data[0][0]+'">';     
                      	var v_in_stock = true;
                      	var v_name = '';
                        var v_sku = p_data.skus[0];
                      	for(var j=0; j<variant_data[0][1].length; j++){
                          if(variant_data[0][1][j][0] == 'Sellable'){
                                v_in_stock = variant_data[0][1][j][1][0]; 	
                          }
                          if(variant_data[0][1][j][0] == 'Size'){
                                v_name = variant_data[0][1][j][1][0];
                          }
                        }
                      	//if(!v_in_stock){
                          if(window.tbmbmCustId){
                      		notify_html = buildNotifyButton(p_data.sku, variant_data[0][0], p_id);
                          }
                      	//}
                        sellableProducts[p_id] = 1;
                      
                      var v_display_name = v_sku+(v_name != 'Regular' ? ' - '+v_name : '');
                      	priceWrapperNewContent += '<span style="width:100%; font-size:13px;"> '+v_display_name+(window.tbmbmCustId ? ' (<span class="vint" id="vint_'+variant_data[0][0]+'">-</span>)</span>' : '');
                      
                    }else{
                       	new_form += '<select name="id" id="productSelect" class="product-single__variants btn--full uppercase" onchange="productAdd2CartFormSizeChange(this)">';
						
                      	for(var i=0; i<variant_data.length; i++){
                          	var v_id = variant_data[i][0];
                          	var v_in_stock = true;
                          	var v_name = '';
                          	var v_sku = p_data.skus[i];
                          	//var v_price = 10;
                          
                          	for(var j=0; j<variant_data[i][1].length; j++){
                              if(variant_data[i][1][j][0] == 'Sellable'){
                                v_in_stock = variant_data[i][1][j][1][0];
                              }
                              if(variant_data[i][1][j][0] == 'Size'){
                                v_name = variant_data[i][1][j][1][0];
                              }
                          	}
                          	var v_display_name = v_sku+(v_name != 'Regular' ? ' - '+v_name : '');
                          	if(!v_in_stock) v_display_name += ' - Sold out';
                          	new_form += '<option class="vint" id="vint_'+v_id+'" value="'+v_id+'" data-stock="'+(v_in_stock?'in':'out')+'" data-sku="'+v_sku+'" data-display="'+v_display_name+'">'+v_display_name+'（-）</option>';

                            //console.log(variant_data);
                            //if(!v_in_stock){
                              notify_html += buildNotifyButton(v_sku, v_id, p_id);
                              //console.log("build this button " + v_sku);
                            //}
                            sellableProducts[p_id] = 1;
						 }
                         new_form += '</select>';
                      
                      
                    }
                  
                  	price_wrapper.html(priceWrapperNewContent ? priceWrapperNewContent : price_wrapper.html());
                    new_form += notify_html+'<input type="number" min="1" size="2" class="quantity" name="quantity" id="quantity" value="1" style="width:26%; margin-left:10px; text-align:center; display:inline-block;" data-_extension-text-contrast="">'+
                      					'<div class="add-to-cart__wrapper"><button type="submit" name="add" class="addToCart add-to-cart lace-product-addToCard-mobile add-to-cart-collection">'+
                                          '<span id="AddToCartText">Add To Cart</span>'+
                                          '</button></div>'+
                                          '</div></form>';
                  if(add_form.length > 0){
                    if(!window.tbmbmCustId)
                    	add_form.replaceWith('');
                    else
                  		add_form.replaceWith(new_form);
                  }else if(variant_data.length > 1){  // multiple variant all sold out.
                    if(!window.tbmbmCustId){
                      new_form = '';
                    }else{
                      new_form = "<form class='product-form isp_add_to_cart_form' onsubmit='return false'>"+new_form+"</form>";
                    }
                  	//console.log("bnnnn");
                  	$(new_form).insertAfter($(this).find('.isp_product_info'));
                  }else{   // single variant sold out, there is no form here, add notify button
                    if(!window.tbmbmCustId){
                    }else{
                      	notify_html = "<form class='product-form isp_add_to_cart_form' onsubmit='return false'>"+notify_html+"</form>";
                    }
                    $(notify_html).insertAfter($(this).find('.isp_product_info'));
					
                  }
                  
                  $(this).find('select').trigger('change');
                  
				});
     
     			
                 if(window.tbmbmCustId){
                   var goPids = [];
                   for(var pppid in sellableProducts){
                     goPids.push(pppid);
                   }
                   if(goPids.length > 0){
                     $.post( '/apps/cart/inventory', { pids: goPids }, function( data ) {
                       var inventory = data.inventory;
                       for(var vvid in inventory){
                        	var intEle = $("#vint_"+vvid);
                         	if(intEle.prop("tagName") != 'OPTION'){
								intEle.text(inventory[vvid]);
                         	}else{
                              	intEle.data('qty', inventory[vvid]);
                         		intEle.text(intEle.data('display') + ' ('+inventory[vvid]+')');
                              	
                              	intEle.data('stock',inventory[vvid] ? 'in' : 'out');
                              	//console.log(intEle, inventory[vvid]);
                         	}
                       }
                       
                       $(".vint").each(function(){
                         if($(this).prop("tagName") == 'SPAN' && $.trim($(this).text()) == '-'){
							$(this).text(0);
                         }else if($(this).prop("tagName") == 'OPTION'){
                           if(!$(this).data('qty')){
                           	$(this).text($(this).data('display') + ' (0)');
                             $(this).data('stock', 'out');
                           }else{
                             $(this).data('stock', 'in');
                           }
                           
                         }
                       });
                       
                       // trigger the variant dropdown to get real action button
                       $(".isp_add_to_cart_form").each(function(){
                         if($(this).find('select').length > 0)
                            $(this).find('select').trigger('change');
                         else if($(this).find('.addToCart').length == 0){
                         	$(this).find('.notify-button').show();
                         }
                       });
                       
                     }, "json");
                   }
                 }
                  
                  
			},
   isp_serp_no_results_callback: function() {  }, // *no* results
   isp_serp_with_product_attributes: '1', // Include product attributes
   isp_add_to_cart_callback: function(product_id, form_id) {},
   isp_serp_quickview_callback: function() { }, // QuickView opened
   isp_serp_look_a_like_txt: 'Related…', // Button text
   isp_serp_articles_tab_name: 'Blog Posts', // CMS tab name
   isp_serp_shopify_image_size: '206x309', // Change default image resolution
   //isp_dropdown_callback: function(li_element) {}, // Dropdown item
   //isp_dropdown_open_callback: function() {}, // Upon dropdown render
  
   isp_dropdown_with_product_attributes: '1', // Include product attributes
   dropdown_align_inputbox: 'right', // Dropdown alignment
   dropdown_narrow_by: [], // Filter by parameters (JSON)
   appendTo: 'div#search_header_id', // Optional element to attach to
   STAR_REVIEWS_POSITION: 1, // 1 above or 0 under price
 };


function buildNotifyButton(sku,vid,pid){
  return '<a href="javascript:;" class="notify-button" id="notify_'+sku+'" style="display:none; color: white; padding: 6px 10px; width: 70%; text-align: center; margin: 0px auto 0px; " onclick="var nfBtn = $(this); if(nfBtn.data(\'nclicked\')){ return false;}else{ nfBtn.data(\'nclicked\',1) }; BIS.create(\''+window.tbmbmCustEmail+'\' , '+vid+' , '+pid+').then(function(resp) { var nele = $(\'<span>You will be notified</span>\'); nele.insertAfter(nfBtn); setTimeout(function(){ nfBtn.next().remove(); nfBtn.data(\'nclicked\',0); }, 2000) });">'+
                      'Notify Me'+
           '</a>';
}
*/
/* search end */